import { call, take, select, put, fork } from 'redux-saga/effects';
import { callApi } from '../../api';
import { fetchProductsCallOptions } from '../../../services/products.services';
import {
  fetchAutoSuggestProduct,
  updateProductEntities,
} from './products.actions';
import { getProductsByIds } from './products.reducer';
import { normalize, schema } from 'normalizr';

const normalizeProduct = (entity: any) => {
  const { product } = entity;

  return {
    ...product,
    imageUrl:
      product.image &&
      product.image.hash &&
      `${process.env.REACT_APP_CDN_URL}${
        product.image.hash
      }?bg=ffffff&width=100&quality=75&width=2000`,
  };
};

export const productSchema = new schema.Entity('product', undefined, {
  processStrategy: normalizeProduct,
  idAttribute: (entity: any) => entity.product && entity.product.id,
});

export function* watchForFetchAutoSuggestProduct() {
  while (true) {
    const {
      payload: { productId, appId },
    } = yield take(fetchAutoSuggestProduct.type);
    const state = yield select();
    const products = yield getProductsByIds(state, appId, [productId]);
    if (products && products.length === 0) {
      yield fork(fetchProductsForAppId, appId, [productId]);
    }
  }
}

export function* fetchProductsForAppId(appId: number, productIds: number[]) {
  const { ok, data } = yield call(
    callApi,
    fetchProductsCallOptions(appId, productIds)
  );

  if (ok && data) {
    const normalized = normalize(data, [productSchema]);
    yield put(
      updateProductEntities({ appId, products: normalized.entities.product })
    );
  }
}



// WEBPACK FOOTER //
// ./src/store/Entities/Products/products.saga.ts